'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_HTTP_TIMEOUT_IN_MS = exports.DEFAULT_HTTP_TIMEOUT_IN_MS = 15000;
var DEFAULT_MESSAGE_ID = exports.DEFAULT_MESSAGE_ID = -1;
var DEFAULT_HISTORY_COUNT = exports.DEFAULT_HISTORY_COUNT = 30;
var DEFAULT_MAX_MESSAGE_LENGTH = exports.DEFAULT_MAX_MESSAGE_LENGTH = 1024;

var MAXIMUM_CHAT_CONFIG_RETRIES = exports.MAXIMUM_CHAT_CONFIG_RETRIES = 2;
var CHAT_CONFIG_CALL_LIMIT = exports.CHAT_CONFIG_CALL_LIMIT = 5;
var CHAT_CONFIG_CALL_TIMEOUT_IN_MS = exports.CHAT_CONFIG_CALL_TIMEOUT_IN_MS = 1000;

var LIST_SIZE_LIMIT = exports.LIST_SIZE_LIMIT = 100;

var OFFLINE_CURRENT_CHANNEL = exports.OFFLINE_CURRENT_CHANNEL = 'offline-channel';
var MOCK_CURRENT_CHANNEL = exports.MOCK_CURRENT_CHANNEL = 'mock-channel';
var WIDGET_CHANNEL_INDEX = exports.WIDGET_CHANNEL_INDEX = 0;